module.exports = __webpack_public_path__ + "img/quill-refresh.e0dc48d5.svg";